module.exports = __webpack_public_path__ + "73549b57a15a8dc2678993ec74078e42.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/symbol-list/image.svg
// module id = 227
// module chunks = 0